
import React from "react";
import { DollarSign, Save } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SaldoHeaderProps {
  saldoTotal: number;
  onSave: () => void;
  isSaving: boolean;
}

const SaldoHeader: React.FC<SaldoHeaderProps> = ({ saldoTotal, onSave, isSaving }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center">
        <DollarSign className="h-5 w-5 text-gray-500" />
        <h2 className="text-xs ml-2 text-gray-700">Saldo</h2>
        <h3 className="ml-4 text-xs text-gray-600">
          {saldoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        </h3>
      </div>
      <Button 
        variant="outline"
        size="sm"
        onClick={onSave}
        disabled={isSaving}
        className="text-gray-500 border-gray-200 hover:bg-gray-50 hover:text-gray-600 text-xs"
      >
        <Save className="h-3 w-3 mr-1" /> {isSaving ? "Salvando..." : "Salvar"}
      </Button>
    </div>
  );
};

export default SaldoHeader;
